import React, { useState } from "react";
import "../HomeMiddle/Statistics.css";
import CountUp from "react-countup";

const Statistics = () => {
  const [count, setCount] = useState(0);

  return (
    <div className="counterContainer">
      <div className="counterInfo">
        <h2 className="counterHeading">
          <CountUp start={0} end={100} duration={2.75} suffix="+"></CountUp>
        </h2>

        <p>Every year on average we sell or let properties</p>
      </div>
      <div className="counterInfo">
        <h2 className="counterHeading">
        <CountUp start={0} end={25} duration={2.75} suffix="+"></CountUp>
        </h2>
        <p>Number of years expertise</p>
      </div>
      <div className="counterInfo">
        {" "}
        <h2 className="counterHeading">
        <CountUp start={0} end={2.3} duration={2.75}  decimals={1} prefix="£" suffix="m +"></CountUp>
        </h2>
        <p>We market over £2.3m worth of properties</p>
      </div>
    </div>
  );
};

export default Statistics;